import * as React from 'react';
import PropType from 'prop-types';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';

function NDropdown(props) {
  const { value, label, onChange, options, id, multiple, onBlur, onClose, selectAll } = props;

  const ITEM_HEIGHT = 80;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      },
    },
    autoFocus: false,
  };

  const isAllSelected = options?.length > 0 && Array.isArray(value) && options.every((opt) => value.includes(opt.value));

  const handleChange = (event) => {
    const {
      target: { value: selectedValue },
    } = event;

    if (selectedValue.includes('select-all')) {
      onChange({
        target: {
          value: isAllSelected ? [] : options.map((opt) => opt.value),
          name: props.name,
        },
      });
      return;
    }

    onChange(event);
  };

  return (
    <div className='App-inputs input-dropdown'>
      <FormControl fullWidth error={props?.error}>
        <InputLabel id={`n-dropdown-select-label${label}`}>{label}</InputLabel>
        <Select
          {...props}
          labelId={`n-dropdown-select-label${label}`}
          id={id}
          value={value}
          label={label}
          onChange={selectAll && multiple ? handleChange : onChange}
          multiple={multiple}
          MenuProps={MenuProps}
          onBlur={onBlur}
          onClose={onClose}
        >
          {selectAll && multiple && options?.length > 0 && (
            <MenuItem value='select-all'>
              <Checkbox
                checked={isAllSelected}
              />
              Select All
            </MenuItem>
          )}
          {options?.length ? options?.map((o) => (
            <MenuItem key={o.value} value={o.value}>
              {multiple ? (
                <>
                  <Checkbox checked={value.indexOf(o.value) > -1} />
                  {o.label}
                </>
              ) : (
                o.label
              )}
            </MenuItem>
          )) : <MenuItem disabled value="">No options available</MenuItem>}
        </Select>
        {props?.helperText && <FormHelperText>{props?.helperText}</FormHelperText>}
      </FormControl>
    </div>
  );
}

NDropdown.propTypes = {
  id: PropType.string,
  error: PropType.bool,
  multiple: PropType.bool,
  selectAll: PropType.bool,
  value: PropType.oneOfType([PropType.string, PropType.number, PropType.array]),
  label: PropType.string,
  helperText: PropType.string,
  onChange: PropType.func,
  onBlur: PropType.func,
  onClose: PropType.func,
  options: PropType.arrayOf(
    PropType.shape({
      label: PropType.oneOfType([PropType.string, PropType.number]),
      value: PropType.oneOfType([PropType.string, PropType.number]),
    }),
  ),
  name: PropType.string,
};

NDropdown.defaultProps = {
  error: false,
  multiple: false,
  selectAll: false,
  value: '',
  id: '',
  label: '',
  helperText: '',
  onChange: () => { },
  onBlur: () => { },
  onClose: () => { },
  options: undefined,
};

export default NDropdown;
